import { render } from "./TeachingPlan.vue?vue&type=template&id=08e302f6&scoped=true"
import script from "./TeachingPlan.vue?vue&type=script&lang=js"
export * from "./TeachingPlan.vue?vue&type=script&lang=js"

import "./TeachingPlan.vue?vue&type=style&index=0&id=08e302f6&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e302f6"]])

export default __exports__